<p>
    edit-refund-method-confirmation works!
</p>